module.exports = __webpack_public_path__ + "img/colexo_web.586475fe.jpg";